var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentPage === 2)?_c('div',[_c('UnidadeSetorDestino',{attrs:{"model":_vm.model,"destinoCentral":""}}),_c('LeituraMateriais',{attrs:{"isBusy":_vm.isBusy,"model":_vm.model,"hideMateriaisGenerico":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }